const WeakIterable = function() {
    const map = new WeakMap();
    const index = [];

    this.add = function(v) {
        var n, l;
        for (n = 0, l = index.length; n < l; n++) {
            if (index[n] === undefined) {
                map.set(v, n);
                index[n] = v;
                return;
            }
        }
        n = index.push(v) - 1;
        map.set(v, n);
    };

    this.delete = function(v) {
        var n = map.get(v);
        if (n === undefined) {
            return;
        }
        map.delete(v);
        delete index[n];
    };

    Object.defineProperty(this, "length", {
        set: () => {},
        get: () => {
            let L = 0;
            for (let n = 0, l = index.length; n < l; n++) {
                if (index[n] === undefined) {
                    continue;
                }
                L += 1;
            }
            return L;
        }
    });

    this[Symbol.iterator] = function*() {
        for (let n = 0, l = index.length; n < l; n++) {
            if (index[n] === undefined) {
                continue;
            }
            yield index[n];
        }
    };
};

export default WeakIterable;
